import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BUSINESS } from "../config/business";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center bg-[#DCCFB9]"
      >
        <div className="font-heading tracking-widest text-[#6E5022] text-2xl text-center">
          {BUSINESS.shortName}
          <div className="text-[#5E4D40] text-xs mt-2 tracking-wider">AUTHENTICATING…</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
